import { fetchFilterData } from '#action/shipment/list-filter';
import { ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { uuidv4 } from '#helper';

const shipmentStatusOptions = [
  { title: 'Not started', value: '100', id: '100' },
  { title: 'In progress', value: '200', id: '200' },
  { title: 'Stopped', value: '300', id: '300' },
  { title: 'Done', value: '400', id: '400' }
];

export const shipmentStatusOpts = shipmentStatusOptions.map(o => new FilterOption(o, o.title));

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search a shipment',
  relatedTo: 'shipment',
  id: uuidv4()
};

const projectComponent = {
  type: 'MultipleSelect',
  name: 'project',
  label: 'Project',
  mobileLabel: 'Shipment project',
  relatedTo: 'shipment',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const shipmentStatusComponent = {
  type: 'MultipleCheckboxes',
  name: 'shipmentStatus',
  label: 'Shipment status',
  relatedTo: 'shipment',
  id: uuidv4(),
  options: shipmentStatusOpts
};

const filterConfig = {
  customActions: {
    fetchFilterData
  },
  searchProps,
  components: [projectComponent, shipmentStatusComponent]
};

export default filterConfig;
